export default __webpack_public_path__ + "static/media/1c50817b-2ed5-41a4-8192-12aa169a734b.1a1c63a2.jpeg";